import { styled } from "@mui/material";

export const ImageWrapper = styled("div")({
  flexShrink: "1",
});

export const Wrapper = styled("div")({
  alignItems: "start",
  display: "flex",
  justifyContent: "left",
});

export const Styles = {
  ImageWrapper,
  Wrapper,
};
